<div class="tw-bg-white tw-rounded-lg tw-shadow-md tw-p-5 tw-flex tw-flex-col tw-w-full tw-h-full tw-justify-between">
    <mh-core-lib-loader-wrapper [loading]="loading" [type]="'spinner'" class="tw-h-full tw-flex tw-flex-col tw-min-h-[8rem]" className="tw-text-3xl">
        <div *ngIf="!error; else errorContainer" class="tw-flex tw-flex-col tw-h-full tw-justify-between">
            <div>
                <div class="tw-flex tw-items-center">
                    <span class="tw-font-medium tw-text-base">{{ title }}</span>
                    <span class="tw-ml-1 tw-text-gray-400 tw-text-base tw-font-medium">{{ subtitle }}</span>
                </div>
                <div class="tw-flex tw-items-center tw-mb-3 tw-mt-2">
                    <span class="tw-text-4xl tw-font-bold">{{ value }}</span>
                    <div class="tw-ml-4">
                        <span *ngIf="icon" class="tw-text-xs tw-mr-1">{{ icon }}</span>
                        <p class="tw-text-sm tw-italic" [class.tw-inline]="icon">{{ description }}</p>
                    </div>
                </div>
            </div>
            <div class="tw-flex tw-items-center tw-mt-2">
                <div class="tw-flex-1"></div>
                <button class="tw-text-main-blue tw-text-base tw-font-semibold tw-uppercase" (click)="goToLink()">{{ 'commons.see_more' | translate }}</button>
            </div>
        </div>

        <ng-template #errorContainer>
            <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full">
                <h2 class="tw-text-2xl tw-font-bold tw-text-main-text">{{ 'commons.error' | translate }}</h2>
                <p class="tw-text-main-text">{{ 'interchain-dashboard.widget_error' | translate }}</p>
            </div>
        </ng-template>
    </mh-core-lib-loader-wrapper>
</div>
